
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import * as echarts from "echarts";
import { moneyFormat } from "@/utils/util";

export interface PieDataType {
  type: string; // percent-百分比，default：数值
  isSimple: boolean; // 是否简单展示，默认展示数值
  data: { name: string; value: string | number }[]; // 数据
}
@Component({
  components: {},
})
export class PieChart extends Vue {
  @Prop({ default: () => ({ type: "", data: [] }) }) params!: PieDataType;
  @Prop({ default: 200 }) pieHeight!: number; // echart 高度
  @Prop({ default: "100%" }) pieWidth!: string; // echart 宽度度
  @Prop({ default: 0 }) pieOffset!: number; // echart 左右偏移位置
  @Prop({ default: "horizontal" }) type!: string; // 图表类型：horizontal-水平，vertical-垂直
  moneyFormat = moneyFormat;
  chart: any = null;
  chartData: any[] = [];
  chartColorList = ["#1A5EF9", "#21CCFF", "#A98ADE", "#3491FA", "#0FC6C2"];
  defaultColor = "#F2F3F5";
  empty = true;
  option: any = {
    series: [
      {
        name: "各类别占比",
        type: "pie",
        width: "100%",
        center: [`${50 + this.pieOffset}%`, "50%"], // 饼图中心位置，默认居中
        radius: "75%", // 调整饼图大小
        data: [],
        label: {
          show: false,
        },
        itemStyle: {
          color: (params: any) => {
            return this.empty
              ? this.defaultColor
              : this.chartColorList[params.dataIndex % 5];
          },
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  @Watch("params", { deep: true })
  onParamsChange() {
    this.getData();
  }

  // 添加对pieHeight的监听
  @Watch("pieHeight")
  onHeightChange() {
    if (this.chart) {
      // 延迟一下确保DOM已更新
      setTimeout(() => {
        this.chart.resize();
      }, 10);
    }
  }

  mounted() {
    this.chart = echarts.init(this.$refs.pieChartRef as HTMLElement);
    this.getData();
    window.addEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (this.chart) {
      this.chart.resize();
    }
  }

  getData() {
    setTimeout(() => {
      // let mockData = [
      //   { name: "微信", value: "12300" },
      //   { name: "支付宝", value: "9810" },
      //   { name: "储值卡", value: "1045" },
      //   { name: "收款码", value: "8536" },
      //   { name: "现金", value: "800" },
      // ];
      this.empty = this.params.data?.every((item) => Number(item.value) === 0);
      this.option.series[0].data = this.empty ? [] : this.params.data;
      this.chartData = this.params.data;
      this.option.series[0].itemStyle.color = (params: any) => {
        return this.empty
          ? this.defaultColor
          : this.chartColorList[params.dataIndex % 5];
      };
      if (this.params.type === "percent" && !this.params.isSimple) {
        this.option.series[0].label = {
          show: true,
          position: "outside", // 标签位置，'inside'（扇形内）/'outside'（外，配引导线）
          distance: 29,
          formatter: (params) => {
            return `${params.value}%`;
          }, // 标签文本，{b} 名称，{c} 数据值
          color: "#4E5969",
        };
        this.option.series[0].labelLine = {
          lineStyle: { color: "#E5E6EB" },
        };
      }
      this.chart.setOption(this.option);
    }, 1000);
  }

  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
export default PieChart;
